import { render, staticRenderFns } from "./EPaginate.vue?vue&type=template&id=2d652aa6"
import script from "./EPaginate.vue?vue&type=script&lang=js"
export * from "./EPaginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports